import React from 'react';
import { connect } from 'react-redux';
import StatisticsMetrics from './StatisticsMetrics.js';
import actions from './StatisticsMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsMetrics.selectors';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';

const reportUtils = ReportComponent.utils;

const StatisticsMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsMetrics);

export default StatisticsMetricsComponent;
